import { Map, List, fromJS } from "immutable";
import { LOCATION_CHANGE } from "react-router-redux";
import { STATE_HYDRATE } from "state/persist";
import { isError } from 'flux-standard-action';
import {nowString} from "lib/date";

import * as actions from "./actions";

const initialState =  new Map({
  clientInitDate: nowString(),
  availableProducts: new List([]),
  isLoadingAvailableProducts: false,
  isMenuOpen: false,
  fatalError: null,
  isDownTimeReporterOpen: true,
  isCustomerNoticesOpen: true,
  lastReadSchoolMoneyCustomerNoticesKey: null,
  lastReadTeachers2ParentsCustomerNoticesKey: null,
  lastReadAppNoticesKey: null,
  userIdentity: new Map({
    status: "unset",
    mobileNumber: null,
    deviceToken: null
  }),
  isInformationModalOpen: false,
  informationModalMessage: "",
  informationModalTitle: "",
  isLoadingFrameOpen: false
});

// Handle FETCH_AVAILABLE_PRODUCTS_COMPLETE
function reduceFetchAvailableProductsComplete(state, action) {
  // set loading state off
  var nextState = state.set("isLoadingAvailableProducts", false);
  // if no error, input payload into state
  if(isError(action)) {
    return nextState;
  } else {
    const appReferrer = state.getIn(["userIdentity", "appReferrer"]);
    return nextState.set("availableProducts", getAvailableProductForReferrer(action.payload, appReferrer));
  }
}


function reduceSetUserIdentity(state, action) {
  if( isError(action) ) {
    return state.set("userIdentity", fromJS({
      status: "error",
      mobileNumber: null,
      deviceToken: null
    }));

  } else {
    return state.set("userIdentity", fromJS({
      ...action.payload,
      status: "success"
    }));
  }
}

function getAvailableProductForReferrer(availableProducts, appReferrer){
    if( appReferrer === process.env.REACT_APP_XPRESSIONS_APP_REFERRER ||
      appReferrer === process.env.REACT_APP_PARENTAPPS_APP_REFERRER ) {
        const teachersProductIndex = availableProducts.indexOf(process.env.REACT_APP_TEACHERS2PARENTS_APP_REFERRER);
        availableProducts.splice(teachersProductIndex, 1);
    }
    return fromJS(availableProducts);
}

function mergeHydrateState(state, action) {
  const hydratedState = action.payload.state;
  // default to the initialised version if the hydrated clientInitDate is undefined
  const clientInitDate = hydratedState.getIn(["app", "clientInitDate"]) || state.get("clientInitDate");
  return state
    .set("availableProducts", hydratedState.getIn(["app", "availableProducts"]))
    .set("clientInitDate", clientInitDate)
    .set("lastReadSchoolMoneyCustomerNoticesKey", hydratedState.getIn(["app", "lastReadSchoolMoneyCustomerNoticesKey"]))
    .set("lastReadTeachers2ParentsCustomerNoticesKey", hydratedState.getIn(["app", "lastReadTeachers2ParentsCustomerNoticesKey"]))
    .set("lastReadAppNoticesKey", hydratedState.getIn(["app", "lastReadAppNoticesKey"]))
    ;
}
// Reducer function (state, action) => state
export default function reducer(state = initialState, action) {
  switch(action.type) {
    case STATE_HYDRATE:
      return mergeHydrateState(state, action);

    case actions.MAIN_MENU_OPEN:
      return state.set("isMenuOpen", true);

    // menu close button, location change both cause menu close
    case actions.MAIN_MENU_CLOSE:
    case LOCATION_CHANGE:
      return state.set("isMenuOpen", false);

    case actions.FETCH_AVAILABLE_PRODUCTS:
      return state.set("isLoadingAvailableProducts", true)

    case actions.FETCH_AVAILABLE_PRODUCTS_COMPLETE:
      return reduceFetchAvailableProductsComplete(state, action);

    case actions.SET_USER_IDENTITY:
      return reduceSetUserIdentity(state, action);

    // client is out of date and about to be reloaded. remove clientInitDate for re-init
    case actions.CLEAR_CLIENT_INIT_DATE:
      return state.delete("clientInitDate" );

    // User is being kicked out. set userIdentity to Error as a precaution
    // This will cause the UserIdentityValidator to
    case actions.FORCE_REGISTRATION:
      return state.setIn(["userIdentity", "status"], "error");

    case actions.ERROR_FATAL:
      return state.set("fatalError", action.payload.error);

    case actions.CLOSE_DOWN_TIME_REPORTER:
      return state.set("isDownTimeReporterOpen", false);

    case actions.CLOSE_CUSTOMER_NOTICES_FRAME:
      return state
        .set("isCustomerNoticesOpen", false);

    case actions.MARK_CUSTOMER_NOTICE_AS_READ:
      return state
        .set("isCustomerNoticesOpen", false)
        .set("lastReadSchoolMoneyCustomerNoticesKey", process.env.REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY)
        .set("lastReadTeachers2ParentsCustomerNoticesKey", process.env.REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY)
        .set("lastReadAppNoticesKey", process.env.REACT_APP_CUSTOMER_NOTICES_KEY);

    case actions.OPEN_INFORMATION_MODAL:
      const { message, title } = action.payload.informationDetails || {};
      return state
        .set("isInformationModalOpen", true)
        .set("informationModalMessage", message)
        .set("informationModalTitle", title === null || title === undefined ? "Alert" : title);

    case actions.CLOSE_INFORMATION_MODAL:
      return state
        .set("isInformationModalOpen", false)
        .set("informationModalMessage", "")
        .set("informationModalTitle", "");

    case actions.OPEN_LOADING_FRAME:
      return state
        .set("isLoadingFrameOpen", true);

    case actions.CLOSE_LOADING_FRAME:
      return state
        .set("isLoadingFrameOpen", false);

      // unknown action; no change
      default:
        return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/app/reducer.js